import { type ReactElement } from 'react';
import {
    LogoMainHorizontal,
    LogoMainHorizontalWhite,
    LogoMainIcon,
    LogoMainIconWhite,
} from '@/components/brand';
import { useTheme } from '@/context/ThemeContext';

/**
 * The horizontal wordmark for app chrome (sidebar). The base wordmark is dark
 * navy on a transparent background, so it renders white in dark mode to stay
 * legible on the dark sidebar surface. Only use on genuinely themed surfaces —
 * not inside `force-light` / `report-paper` islands.
 */
export const SidebarBrandLogo = (): ReactElement => {
    const { resolvedTheme } = useTheme();
    return resolvedTheme === 'dark' ? <LogoMainHorizontalWhite /> : <LogoMainHorizontal />;
};

/**
 * The compact icon mark for the collapsed sidebar. Same rationale as
 * {@link SidebarBrandLogo}: the base icon is a transparent blue glyph, so it
 * renders white in dark mode to match the white wordmark.
 */
export const SidebarBrandIcon = (): ReactElement => {
    const { resolvedTheme } = useTheme();
    return resolvedTheme === 'dark' ? <LogoMainIconWhite /> : <LogoMainIcon />;
};
